export const searchOptions = [
	{ value: 'name', label: 'Driver Name' },
	{ value: 'phone', label: 'Phone Number' }
];
